import { AxiosError } from 'axios';

import { ApiResponse } from '@/types';

export const getApiErrorMessage = (error: unknown) => {
  const data = (error as AxiosError)?.response?.data as ApiResponse<string>;
  return data?.errorMessage;
};
